import React from 'react'
import SushiLogo from '../../assets/images/logo_text.png'
import CateringLogo from '../../assets/images/panda-catering-logo-outlined.png'
import { useTranslation } from 'react-i18next'
import { useAppNavigate, useAppType } from '../../context/AppContext'
import './HeaderMenu.scss'

const c = 'header-menu'

const HeaderMenu = () => {
  const navigate = useAppNavigate()
  const { t } = useTranslation()
  const appType = useAppType()
  const Logo = appType === 'catering' ? CateringLogo : SushiLogo

  return (
    <div className={c}>
      <div className={`${c}__container`}>
        <div className={`${c}__container-menu`}>
          <div className={`${c}__container-menu-logo`}>
            <img src={Logo} alt='logo' onClick={() => navigate('/')} />
          </div>
          <div className={`${c}__container-menu-links`}>
            <div
              className={`${c}__container-menu-links-link`}
              onClick={() => navigate('/')}
            >
              {t('MENU')}
            </div>
            <div
              className={`${c}__container-menu-links-link`}
              onClick={() => navigate('/delivery-conditions')}
            >
              {t('DELIVERY_CONDITIONS')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderMenu
